const FAQ = {
  SET_FAQ_QUERY: 'SET_FAQ_QUERY',
};

export default FAQ;
